module.exports = __webpack_public_path__ + "static/media/up-right-and-down-left-from-center-solid.839b733e.svg";